import { ExternalLink } from "lucide-react";
import { CA, GMGN_URL } from "../config";
import { copyCa } from "./CopyButton";
import Mascot from "./Mascot";
import Reveal from "./Reveal";

export default function FinalCta() {
    return (
        <section
            id="final"
            data-testid="final-cta-section"
            className="relative overflow-hidden py-28 text-center lg:py-40"
        >
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_55%_55%_at_50%_45%,rgba(245,197,24,0.10),transparent),radial-gradient(ellipse_40%_40%_at_20%_80%,rgba(168,85,247,0.10),transparent)]" />
            <div className="relative mx-auto max-w-5xl px-4 sm:px-6">
                <Reveal>
                    <div className="relative mx-auto max-w-md lg:max-w-lg" data-testid="final-mascot">
                        <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[80%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(245,197,24,0.28),transparent_65%)] blur-2xl" />
                        <Mascot
                            name="king"
                            className="mx-auto w-full drop-shadow-[0_30px_70px_rgba(245,197,24,0.22)]"
                        />
                        <div className="shine-sweep" aria-hidden="true" />
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="headline mt-10 text-5xl text-white sm:text-6xl lg:text-7xl">
                        NO HAIR.
                        <br />
                        NO BRAKES.
                        <br />
                        <span className="text-gradient">JUST MEMES.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <a
                            href={GMGN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="final-get-bald-button"
                            className="btn-primary w-full sm:w-auto !px-12 !py-5 text-lg"
                        >
                            GET BALD 🧑‍🦲 <ExternalLink className="h-5 w-5" />
                        </a>
                        <button
                            type="button"
                            data-testid="final-copy-ca-button"
                            onClick={copyCa}
                            className="btn-ghost w-full sm:w-auto"
                        >
                            COPY CA
                        </button>
                    </div>
                    <p className="mt-8 break-all px-4 font-mono text-xs text-slate-500 md:text-sm" data-testid="final-ca-line">
                        {CA}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
